import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { extractDuration } from 'smash-time';

@Pipe({
  name: 'discountDuration'
})
export class DiscountDurationPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(duration: string): string {
    if (!duration) {
      return '';
    }

    try {
      const { quantity, unit } = extractDuration(duration);

      // Get the translation key based on the unit
      let unitKey: string;
      switch (unit) {
        case 'years':
          unitKey = 'DURATION_YEARS';
          break;
        case 'months':
          unitKey = 'DURATION_MONTHS';
          break;
        case 'weeks':
          unitKey = 'DURATION_WEEKS';
          break;
        case 'days':
          unitKey = 'DURATION_DAYS';
          break;
        default:
          // Fallback to English if no translation found
          const unitText = quantity === 1 ? unit.replace(/s$/, '') : unit;
          return `${quantity} ${unitText}`;
      }

      // Use ICU plural format with variable interpolation
      return this.translate.instant(unitKey, { count: quantity });
    } catch (error) {
      return duration;
    }
  }

}
